<template>
  <div class="card no-body">
    <div class="card-header d-flex">
        <h5 class="h3 mb-0">Recent Manifests</h5>
        <b-button @click="goTo" size="sm" v-b-popover.hover.left="'Go to Job Search Page'" variant="outline-primary" class="ml-auto">View All</b-button>
    </div>

    <div v-if="session.loadedFirstPage">
        <div v-if="session.manifests.length > 0">
            <b-list-group flush class="job-list-group">
              <b-list-group-item v-for="manifest in session.manifests" :key="manifest.manifestId" class="mx-0 p-0 py-1">
                <b-card no-body class="overflow-hidden m-0 p-0">
                  <b-row no-gutters>
                    <b-col class="hw-fixed">
                      <manifest-media-wrapper :manifest="manifest"></manifest-media-wrapper>
                    </b-col>
                    <b-col align-self="center" class="col-width">
                      <b-card-body class="pb-2 pt-2 text-truncate text-center align-items-center" >
                        <router-link :to="`/manifests/${manifest.manifestId}`"><h5 class="card-title m-0 ">{{ manifest.manifestName }}</h5></router-link>
                        <!-- <div><small>{{ entity.size | bytes }}</small></div> -->
                        <div><small class="text-muted">{{ manifest.dateCreated | moment("from") }}</small></div>
                      </b-card-body>
                    </b-col>
                    <add-manifest-to-cart :manifestId="manifest.manifestId"></add-manifest-to-cart>
                  </b-row>
                </b-card>
              </b-list-group-item>
            </b-list-group>
        </div>
        <div v-else class="text-center p-3">
            <div> No manifest in this project yet. </div>
        </div>
    </div>
    <div v-else class="text-center p-3">
      <b-spinner size="sm"></b-spinner>
    </div>
    <div class="card-footer">
      <b-form-invalid-feedback :state="!session.errorMessage" class="text-center">
          {{session.errorMessage}}
      </b-form-invalid-feedback>
    </div>
  </div>
</template>

<script>
import ManifestMediaWrapper from '#/ui/Components/Manifest/ManifestMediaWrapper.vue';
import { ManifestListSession } from '#/services/manifests';
import AddManifestToCart from '#/ui/Components/Manifest/AddManifestToCart.vue';

export default {
  components: {
    ManifestMediaWrapper,
    AddManifestToCart,
  },
  data() {
    const accountId = this.$store.getters.activeAccountId;
    const projectId = this.$store.getters.activeProjectId;
    return {
      session: new ManifestListSession(accountId, projectId),
    };
  },
  created() {
    return this.loadPage();
  },
  methods: {
    async loadPage() {
      return this.session.loadPage();
    },
    goTo() {
      const path = '/manifests';
      this.$router.push(path);
    },
  },
};
</script>
<style scoped>
.hw-fixed{
  width: 274px;
}
</style>
